module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "document"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDisclosureInformation(_vm.document.id)
      }
    }
  }), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.showType),
      callback: function($$v) {
        _vm.$set(_vm.document, "showType", $$v)
      },
      expression: "document.showType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Документ",
      "name": "document"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Название документа"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название документа"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.name),
      callback: function($$v) {
        _vm.$set(_vm.document, "name", $$v)
      },
      expression: "document.name"
    }
  })], 1), _vm._v(" "), (!_vm.document.file) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleloadFile
    }
  }, [_vm._v("\n            Загрузить документ\n          ")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm._f("path")(_vm.document.file)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteDisclosureInformationFile(_vm.document.id)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Ссылка",
      "name": "url"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название cсылки"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.name),
      callback: function($$v) {
        _vm.$set(_vm.document, "name", $$v)
      },
      expression: "document.name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите ссылку"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.document.url),
      callback: function($$v) {
        _vm.$set(_vm.document, "url", $$v)
      },
      expression: "document.url"
    }
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f331a45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/DisclosureItem.vue
// module id = 933
// module chunks = 0